<template lang="pug">
	full-width-page
		div.text-center.pa-3.pa-md-12.mb-12(:style="{backgroundPosition: 'center center', backgroundImage: `url(${require('~/assets/images/acco_search_header.jpg')})`}")
			.align-items-center
				h1.text-md-h3.white--text.font-weight-bold(style="text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5); display:block !important") {{contentpage.name}}
				v-card.rounded-xl.ma-md-12
					v-form(@submit.prevent="submitSearch")
						v-container(max-width="800")
							v-row
								v-col.grow(cols="12" md="auto")
									destination-search.no-border.px-3(label="Bestemming of accommodatie" :append-icon="null" :types="['resorts', 'areas', 'regions', 'countries']" hide-details persistent-placeholder placeholder="Waar ga je naartoe?" :menu-props="{ 'offset-y': true, 'nudge-top': 2, 'nudge-width': 48, 'nudge-left': 24}" v-model="destination")
								v-divider(:vertical="this.$vuetify.breakpoint.mdAndUp")
								v-col.grow(cols="12" md="auto")
									v-text-field.no-border.px-3(readonly hide-details persistent-placeholder placeholder="Wanneer?" label="Aankomstdatum" @click="departureModal = true" :value="date ? $dayjs(date).format('DD MMM YYYY') : null")
									ws-dialog(v-model="departureModal" :title="$t('global.snowalarm.form.departure')")
										v-row(no-gutters)
											v-col.shrink(v-for="month in ['2024-02', '2024-03', '2024-04', '2024-12', '2025-01', '2025-02', '2025-03', '2025-04']" :key="month")
												v-date-picker.snow-alarm--datepicker.elevation-0(v-model="date" width="250" :min="new Date().toISOString().substr(0, 10)" :picker-date="month" first-day-of-week="1" no-title  @input="departureModal = false" :locale="$i18n.locale")
								v-divider(:vertical="this.$vuetify.breakpoint.mdAndUp")
								v-col.grow(cols="12" md="auto")
									v-select.no-border.px-3(label="Aantal nachten" :append-icon="null" return-object hide-details persistent-placeholder placeholder="Hoelang?" :items="nightOptions" :menu-props="{ 'offset-y': true, 'nudge-top': 2, 'nudge-width': 48, 'nudge-left': 24}" v-model="selectedDuration")
								v-divider(:vertical="this.$vuetify.breakpoint.mdAndUp")
								v-col.grow(cols="12" md="auto")
									v-select.no-border.px-3(label="Aantal personen" :append-icon="null" hide-details persistent-placeholder placeholder="Wie?" :items="personsOptions" :menu-props="{ 'offset-y': true, 'nudge-top': 2, 'nudge-width': 48, 'nudge-left': 24}" v-model.number="persons")
								v-col.pa-2.shrink(align-self="center" v-if="$vuetify.breakpoint.mdAndUp")
									v-btn.gradient(rounded :disabled="!filterstring.length" icon x-large nuxt type="submit")
										v-icon(large) search
								v-col.pa-2(v-else)
									v-btn.gradient( style="border-radius: 10px" :disabled="!filterstring.length" rounded block large nuxt type="submit")
										.text-h6.font-weight-bold zoeken

				p.white--text.font-weight-bold(style="text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5)") Twijfel je nog over je bestemming?
				v-form(@submit.prevent="submitSearch")
					v-btn(depressed color="primary" nuxt type="submit") toon mij alle accommodaties
		v-container.pa-0
			v-row(dense)
				v-col(cols="12" md="6")
					.font-weight-bold
						v-avatar.mr-2(color="success" size="36")
							ws-icon(color="white") thumbs-up
						| De beste prijsvergelijker voor wintersport accommodaties
					p Elk uur controleren wij prijzen van meer dan 25 reisorganisaties. Om je wintersportvakantie in 2023/2024 eerlijk te vergelijken gaan we uit van een totaalprijs inclusief skipas. Bij reizen waar een skipas niet is inbegrepen tonen wij de prijs van de skipas die je zult betalen bij het skigebied zelf. Zo heb je altijd een eerlijk overzicht!
				v-col(cols="12" md="6")
					.font-weight-bold
						v-avatar.mr-2(color="success" size="36")
							v-icon(color="white") bolt
						| Optie om direct te boeken op wintersport.nl
					p Je ziet bij ons een overzicht van de wintersportvakanties van de organisaties met wie wij samenwerken. Soms sturen we je door naar de website van de aanbieder, maar in sommige gevallen kun je je accommodatie direct boeken op Wintersport.nl. Deze reis wordt dan nog altijd wel uitgevoerd door de aanbieder, bijvoorbeeld Belvilla of Interhome.
		v-container.pa-0
			v-row(dense)
				v-col(cols="12" md="6")
					ad(location="accolanding")
		ws-content(:value="contentpage.content")

			template(slot="destinations")
				v-container.mb-12.px-0
					v-row
						v-col.py-0(v-for="({node: area}, i) in areas" cols="12" md="3" :key="`area-list-${i}`")
							img.flag(:src="`https://static.wintersport.nl/images/flags/svg/${area.country.countryCode}.svg`" :alt="area.name")
							nuxt-link(:to="localePath({name: 'areas-area-accommodationtype', params: { area: area.slug, accommodationtype: $localeSlug('accommodations', $i18n.locale) }})") {{area.name}}


</template>

<script>
import gql from 'graphql-tag';
import MinimumFilter from '@dengl/site/components/accommodations/minimum-filter.vue';
import Content from '@dengl/common/components/content.vue';
import { encodeFilters } from '@dengl/common/utils/filterstrings';
import dayjs from 'dayjs';
import FullWidthPage from '@/components/pages/full-width-page.vue';
import DestinationSearch from '@/components/common/destination-search';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const query = gql`
	query AccommodationsearchLanding($path: String) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
		areasElastic(filters: "at:fr:ch:it:de", limit: 20) {
			edges {
				node {
					id
					name
					slug
					country {
						id
						countryCode
					}
				}
			}
		}
		me {
			id
			otaTrips {
				bookingId
				name
			}
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	name: 'AccommodationsIndex',
	components: {
		FullWidthPage,
		DestinationSearch,
		MinimumFilter
	},
	scrollToTop: true,
	nuxtI18n: {
		paths: {
			'nl-NL': '/accommodatie',
			'nl-BE': '/accommodatie'
		}
	},
	// eslint-disable-next-line @milqmedia/milq/page-has-meta
	asyncData({ app, route }) {
		return app.$graphClient
			.query({
				query,
				variables: {
					path: route.path
				},
				errorPolicy: 'all'
			})
			.then(({ data, _errors }) => {
				app.meta(data.contentpage.meta);
				app.ads({
					accolanding: { visible: true, type: 'accommodation' }
				});
				return {
					areas: data.areasElastic.edges,
					trips: data.me.otaTrips,
					contentpage: data.contentpage
				};
			});
	},
	data() {
		return {
			selectedDuration: null,
			persons: null,
			destination: null,
			date: null,
			departureModal: false
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		duration() {
			return this.selectedDuration && this.selectedDuration.nights;
		},
		nightOptions() {
			return [
				{ text: '1 week', nights: 7, value: 'week' },
				{ divider: true },
				...[...Array(14).keys()].map(index => {
					const nights = index + 1;
					return {
						text: this.$tc('accommodations-filters.nights', nights),
						nights,
						value: nights
					};
				})
			];
		},
		personsOptions() {
			return [...Array(50).keys()].map(index => {
				const persons = index + 1;
				return {
					text: this.$tc('accommodations-filters.persons', persons),
					value: persons
				};
			});
		},
		filterstring() {
			let destinationFilter = {};
			if (this.destination) {
				switch (this.destination.type) {
					case 'Resort':
						destinationFilter = { resortslugs: [this.destination.slug] };
						break;
					case 'Area':
						destinationFilter = { areaslugs: [this.destination.slug] };
						break;
					case 'Region':
						destinationFilter = { regions: [this.destination.slug] };
						break;
					case 'Country':
						destinationFilter = { countries: [this.destination.countryCode] };
						break;

					default:
						break;
				}
			}

			return encodeFilters(
				{
					date: this.date,
					persons: this.persons,
					duration: this.duration,
					...destinationFilter
				},
				this.$i18n.locale
			);
		}
	},
	watch: {
		date(val) {
			if (val) this.updateFiltersInStorage({ date: val });
		},
		duration(val) {
			if (val) this.updateFiltersInStorage({ duration: val });
		},
		persons(val) {
			if (val) this.updateFiltersInStorage({ persons: val });
		}
	},
	mounted() {
		let filtersFromStorage = localStorage.getItem('minimumFilters');
		if (filtersFromStorage) {
			filtersFromStorage = JSON.parse(filtersFromStorage);
			if (
				filtersFromStorage.date &&
				dayjs().isBefore(dayjs(filtersFromStorage.date, 'YYYY-MM-DD'))
			)
				this.date = filtersFromStorage.date;
			if (filtersFromStorage.duration)
				this.selectedDuration = this.nightOptions.find(
					option => option.nights === filtersFromStorage.duration
				);
			if (filtersFromStorage.persons) this.persons = filtersFromStorage.persons;
		}
	},
	methods: {
		updateFiltersInStorage(filter) {
			let filtersFromStorage = localStorage.getItem('minimumFilters');
			filtersFromStorage = filtersFromStorage
				? JSON.parse(filtersFromStorage)
				: {};
			localStorage.setItem(
				'minimumFilters',
				JSON.stringify({ ...filtersFromStorage, ...filter })
			);
		},
		submitSearch() {
			if (this.destination && this.destination.type === 'Accommodation') {
				this.$router.push(
					this.localePath({
						name: 'accommodations-search-id',
						params: { id: this.destination.slug },
						hash: this.filterstring.length ? `#${this.filterstring}` : ''
					})
				);
			} else {
				this.$router.push(
					this.localePath({
						name: 'accommodations-search',
						hash: this.filterstring.length ? `#${this.filterstring}` : ''
					})
				);
			}
		}
	}
};
</script>

<style lang="sass">
.no-border > .v-input__control > .v-input__slot
	&:before
		display: none !important
</style>
